module.exports = __webpack_public_path__ + "static/media/linked-in.d723d6a0.png";